<div class="payment-types">
  <a class="payment-types__link" href="https://usa.visa.com/" target="_blank">
    <img
      class="payment-types__image"
      src="assets/visa.svg"
      width="20"
      height="7.8"
      alt="Visa"
    />
  </a>
  <a
    class="payment-types__link"
    href="https://www.mastercard.us/"
    target="_blank"
  >
    <img
      class="payment-types__image"
      src="assets/mastercard.svg"
      width="564.5"
      height="366.9"
      alt="Mastercard"
    />
  </a>
</div>
